interface FinanceCompanyConfig {
  financeCompanyId: number;
  name: string;
  logo: string;
}

const financeCompanies = [
  {
    financeCompanyId: 50,
    name: "Alphera",
    logo: "alphera-logo.png"
  },
  {
    financeCompanyId: 63,
    name: "BNP Paribas",
    logo: "bnp-logo.svg"
  },
  {
    financeCompanyId: 21,
    name: "Close Finance",
    logo: "close-finance-logo.svg"
  },
  {
    financeCompanyId: 70,
    name: "Close Brothers",
    logo: "close-brothers.svg"
  },
  {
    financeCompanyId: 22,
    name: "Moneyway",
    logo: "moneyway-logo.png"
  },
  {
    financeCompanyId: 46,
    name: "Moneway (Prime)",
    logo: "moneyway-logo.png"
  },
  {
    financeCompanyId: 67,
    name: "Motonovo",
    logo: "motonovo-logo.png"
  },
  {
    financeCompanyId: 16,
    name: "MotoNovo Finance",
    logo: "motonovo-logo.png"
  },
  {
    financeCompanyId: 9,
    name: "Moneybarn",
    logo: "moneybarn-logo.webp"
  },
  {
    financeCompanyId: 44,
    name: "Ratesetter",
    logo: "ratesetter-logo.png"
  },
  {
    financeCompanyId: 48,
    name: "Blur Motor Finance",
    logo: "bluemotor-logo.png"
  },
  {
    financeCompanyId: 68,
    name: "Lendable",
    logo: "lendable-logo.png"
  },
  {
    financeCompanyId: 69,
    name: "Metro",
    logo: "metro-logo.png"
  },
  {
    financeCompanyId: 66,
    name: "V12 Finance",
    logo: "v12-retail-logo.png"
  },
  {
    financeCompanyId: 65,
    name: "Aldermore",
    logo: "aldermore-logo.svg"
  },
  {
    financeCompanyId: 39,
    name: "Startline Finance",
    logo: "startline-logo.svg"
  },
  {
    financeCompanyId: 58,
    name: "Oodle",
    logo: "oodle-logo.png"
  },
  {
    financeCompanyId: 64,
    name: "Oodle (Prime)",
    logo: "oodle-logo.png"
  },
  {
    financeCompanyId: 29,
    name: "Billing Finance",
    logo: "billing-logo.png"
  },
  {
    financeCompanyId: 8,
    name: "Advantage Finance",
    logo: "advantage-logo.svg"
  },
  {
    financeCompanyId: 62,
    name: "Mann Island Finance",
    logo: "mann-island-logo.png"
  },
  {
    financeCompanyId: 53,
    name: "Specialist Motor Finance",
    logo: "specialist-finance-logo.png"
  },
  {
    financeCompanyId: 49,
    name: "CarFinance 247",
    logo: "CarFinance247_logo_purple.svg"
  },
  {
    financeCompanyId: 71,
    name: "Automoney",
    logo: "automoney-logo.jpeg"
  },
  {
    financeCompanyId: 72,
    name: "Tandem",
    logo: "tandem-logo.svg"
  },
  {
    financeCompanyId: 73,
    name: "Zopa",
    logo: "zopa-logo.svg"
  },
  {
    financeCompanyId: 74,
    name: "Credit Agricole",
    logo: "credit-agricole-logo.svg"
  },
  {
    financeCompanyId: 75,
    name: "Northridge Finance",
    logo: "northridge-logo.png"
  },
] as FinanceCompanyConfig[]

export {
  FinanceCompanyConfig,
  financeCompanies as FinanceCompanies
}
